<template>
  <div
    id="home"
    :style="{
      backgroundColor: cartList.length ? '#fff' : '#fff',
      height: '100vh',
    }"
  >
    <van-pull-refresh
      v-if="cartList.length"
      v-model="isLoading"
      @refresh="onRefresh"
      style=""
    >
      <t-cart
        v-for="item in cartList"
        :key="item.id"
        :content="item"
        @click.native="handleToDetail(item)"
      ></t-cart>
      <section>
        <van-loading type="spinner" v-if="loading" />
        <section v-else>
          <span>点击</span
          ><a @click="getLastZiXunData" style="color: #1989fa">刷新</a>
        </section>
      </section>
    </van-pull-refresh>
    <section v-else>
      <van-empty description="暂无资讯" />
      <van-loading type="spinner" v-if="loading" />
      <section v-else>
        <span>点击</span
        ><a @click="getLastZiXunData" style="color: #1989fa">刷新</a>
      </section>
    </section>
  </div>
</template>

<script>
import Cart from "./components/cart";
import { format } from "date-fns";
import _ from "lodash";
import { zxIndex } from "@/api/zixun";
export default {
  data() {
    return {
      isLoading: false,
      cartList: [],
      params: {
        page: 3,
        current: 1,
      },
      pagination: {
        pageSize: 10,
        current: 1,
      },
      dataLength: 0,
      typeId: this.$route.query.id,
      loading: false,
    };
  },
  created() {},
  mounted() {
    this.getZixunData();
  },
  components: {
    "t-cart": Cart,
  },
  methods: {
    onRefresh() {
      this.pagination.current += 1;
      this.getZixunData();
    },

    // /**
    //  * @Description: 下拉加载
    //  * @param {*}
    //  * @Date: 2020-11-18 16:53:37
    //  */

    // onLoad() {
    //   // this.pagination.current = 1;
    //   this.getLastZiXunData();
    // },

    getLastZiXunData() {
      // this.loading = true;
      this.cartList = [];
      this.getZixunData();
      // axios.post(prefix+'/v1/app/infromation/page',{
      //   pageModel: {
      //     "size": 1,
      //     "current": 1,
      //   },
      //   typeId: this.typeId,
      //   isPublish: 1,
      // }).then(res => {
      //   if(!res.data.data.voList.length) {
      //     return null
      //   }
      //   Toast('加载成功！');
      //   const cartList = res.data.data.voList.map(item => {
      //     return {
      //       title: item.informationHeadline,
      //       desc: item.describeHeadline,
      //       images: item.imgPath ? item.imgPath.split(',') : [],
      //       id: item.id,
      //       publishTime: format(item.publishDate, 'yyyy-MM-dd HH:mm:ss'),
      //       publishDate: item.publishDate
      //     }
      //   })
      //   if(cartList[0].id === this.cartList[this.cartList.length - 1].id) {
      //   } else {
      //     this.sortCartList(cartList, 'last')
      //   }
      //   this.loading = false
      // })
    },

    /**
     * @Description: 获取资讯列表
     * @param {*}
     * @Date: 2020-11-17 15:53:19
     */
    async getZixunData() {
      // this.createMokeData().then((res) => {
      //   this.cartList = res
      //   this.$nextTick(() => {
      //     let ele = document.getElementById('home');
      //     setTimeout(()=> {
      //       ele.scrollTop = ele.scrollHeight;
      //     }, 100)

      //   })
      // })
      try {
        this.loading = false;
        this.isLoading = false
        let { data } = await zxIndex({
          BraveCollect: 0,
          // current: 1,
          isPublish: 1,
          pageModel: {
            current: 1,
            size: 10,
          },
          // size: 10,
          // userId: 10047490,
        });
        console.log(data,22222);
        this.cartList = data.records.map((item) => {
          return {
            ...item,
            title: item.informationHeadline,
            desc: item.describeHeadline,
            images: item.imgPath ? item.imgPath.split(",") : [],
            id: item.id,
            publishTime: format(item.publishDate, "yyyy-MM-dd HH:mm:ss"),
            publishDate: item.publishDate,
          };
        });
        console.log(this.cartList,111111111);
        // this.sortCartList(this.cartList, "prev");
        // if (this.pagination.current === 1) {
        //   this.$nextTick(() => {
        //     let ele = document.getElementById("home");
        //     setTimeout(() => {
        //       ele.scrollTop = ele.scrollHeight;
        //     }, 100);
        //   });
        // }
      } catch (error) {
        this.isLoading = false;
        this.loading = false;
      }
    },

    createMokeData() {
      let cartList = [];
      for (let i = 0; i < 10; i++) {
        cartList.push({
          title: `这是主标题${i}`,
          publish: "2020-10-21",
          desc: "这是副标题",
          images: [
            "https://ns-strategy.cdn.bcebos.com/ns-strategy/upload/fc_big_pic/part-00327-2972.jpg",
            "https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=2445265922,2506991961&fm=26&gp=0.jpg",
          ],
        });
      }
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(cartList);
        });
      });
    },

    /**
     * @Description: 给卡片列表排序
     * @param {*}
     * @Date: 2020-11-18 15:57:41
     */
    sortCartList(cartList, sortType) {
      cartList = _.sortBy(cartList, (item) => {
        return item.publishDate;
      });
      if (sortType === "last") {
        this.cartList = [...this.cartList, ...cartList];
      } else {
        this.cartList = [...cartList, ...this.cartList];
      }
    },

    /**
     * @Description: 跳转详情页
     * @param {*}
     * @Date: 2020-11-12 14:34:48
     */
    handleToDetail(value) {
      wx.miniProgram.navigateTo({
        url: "/packageWebView/pages/zixun-details/zixun-details?id="+value.id,
      });
      // this.$router.push({ name: "detail", query: { id: value.id } });
    },
  },
};
</script>

<style lang="less">
#home {
  padding: 20px;
  // background-color: #eee;
  min-height: 100vh;
  box-sizing: border-box;
  overflow-y: scroll;
  section {
    text-align: center;
    font-size: 16px;
  }
}
</style>
